import getProp from 'lodash.get';
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';


function calculatePasswordStrength(password) {
	if (!password) {
		return 0;
	}
	let strength = 0;
	// lowercase, uppercase, numbers, symbols
	const tests = [/[a-z]+/, /[A-Z]+/, /[0-9]+/, /[$-/:-?{-~!^_`[\]]/g];
	const passedMatches = tests.reduce((passed, test) => test.test(password) ? passed + 1 : passed, 0);
	strength += 2 * password.length + ((password.length >= 10) ? 1 : 0);
	strength += passedMatches * 10;
  
	strength = (password.length <= 6) ? Math.min(strength, 10) : strength;
	strength = (passedMatches === 1) ? Math.min(strength, 10) : strength;
	strength = (passedMatches === 2) ? Math.min(strength, 20) : strength;
	strength = (passedMatches === 3) ? Math.min(strength, 40) : strength;
  
	return Math.floor((strength - 1) / 10) + 1;
}


const PasswordStrength = ({values, propToCheck = 'password', label}) => {
	const value = getProp(values, propToCheck, '');
	const strength = calculatePasswordStrength(value);

	let progress = strength * 20;
	if(progress > 100) {
		progress = 100;
	}

	return (
		<div style={{width: '100%', marginBottom: '2rem', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
			<label>{label}</label>
			<div style={{flexGrow: 1, marginLeft: '1rem'}}>
				<LinearProgress variant='determinate' value={progress} />
			</div>
		</div>
	);

};


PasswordStrength.type = 'PasswordStrength';
export default PasswordStrength;